function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.5,
  width: 28,
  height: 28,
  rx: 4,
  fill: "#252CA0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.5 6.5C10.3779 6.5 7 9.87793 7 14C7 18.1221 10.3779 21.5 14.5 21.5C18.6221 21.5 22 18.1221 22 14C22 9.87793 18.6221 6.5 14.5 6.5Z",
  fill: "url(#paint0_linear_15376_421304)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.457 13.1211V14.8789H15.3809V17.9551H13.623V14.8789H10.5469V13.1211H13.623V10.0449H15.3809V13.1211H18.457Z",
  fill: "#F2F2F2"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.4551 13.1211V14.8789H15.3789V17.9551H14.5V10.0449H15.3789V13.1211H18.4551Z",
  fill: "#E7E7F2"
});

var _ref6 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_15376_421304",
  x1: 22.3008,
  y1: 6.5,
  x2: 4.31721,
  y2: 16.9125,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EA4AC7"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B960CC"
})));

var SvgAddActive = function SvgAddActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAddActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add_active.6df13613.svg";
export { ForwardRef as ReactComponent };